var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.81322 9.9703C8.56418 10.5604 14.7251 13.2429 19.6446 17.3663C20.3726 17.9794 21.4454 17.9258 22.1121 17.2513L26.5872 12.7754C27.3458 12.0166 27.2845 10.7827 26.4799 10.0776C26.25 9.87833 26.0201 9.68672 25.7902 9.49512C24.7481 8.63672 23.6676 7.82431 22.5489 7.07322C20.8707 5.93891 19.1006 4.91957 17.2615 4.03052C16.0354 3.44037 14.7711 2.90387 13.4837 2.43636C11.545 1.73125 9.54502 1.15643 7.49138 0.734897C5.74426 0.374678 3.95116 0.137086 2.13507 0.00679438C1.06993 -0.069848 0.150391 0.773218 0.150391 1.84621V8.15388C0.150391 9.09658 0.870696 9.89366 1.81322 9.97796V9.9703Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector6);
export default __webpack_public_path__ + "static/media/Vector-6.d4e9f372ea3c023002531122b9bce650.svg";
export { ForwardRef as ReactComponent };